export default __webpack_public_path__ + "static/logo-bethel-ffa6e67ec9a31ca904ea0972fe5eee78.png";